@if (!logoState().image || logoState().error()) {
  <a href="https://www.23degrees.io" target="_blank" [ngStyle]="containerStyle()">
    <!-- fallback logo -->
    <i #fallbackLogo class="icon-logo layout-logo" [ngStyle]="logoStyle()" style="color: #000"></i>
  </a>
}

@if (logoState().image && !logoState().error()) {
  <div [ngStyle]="containerStyle()">
    <img alt="Logo" [src]="logoState().image" (error)="imgError($event)" (load)="imgLoad($event)" [ngStyle]="logoStyle()" />
  </div>
}
